
import { defineComponent } from 'vue'
import Header from '@/components/base/Header.vue'
import Footer from '@/components/base/Footer.vue'
import Iframe from '@/components/base/Iframe.vue'

export default defineComponent({
  name: 'Conditions',
  components: {
    Header,
    Footer,
    Iframe
  },
  data: function () {
    return {
      isLoggedIn: !!localStorage.getItem('authToken')
    }
  }
})
